<template>
  <div>
    <span v-if="fullMode" class="mapInd-label"><strong>Indicator:</strong></span>
    <IndSelect
      v-if="fullMode"
      id="mapIndSelect"
      v-bind:indFromName="indFromName"
      v-bind:value="mappedIndicator"
      v-on:input="setIndicator($event)"
    />
    <span v-if="fullMode" class="normInd-label"><strong>Normalized by:</strong></span>
    <IndSelect
      v-if="fullMode"
      id="normIndSelect"
      v-bind:indFromName="indFromName"
      v-bind:value="normalizationIndicator"
      v-on:input="setNormalization($event)"
    />
    <span v-if="!fullMode" id="shortcutMode">
      <select v-model="dropdownShortcut" class="name">
        <option disabled v-bind:value="undefined" v-if="!selectedShortcut"
                selected>Custom Map</option>
        <option disabled value="">Choose an Indicator</option>
        <optgroup
          v-for="gName in groupNames"
          v-bind:key="gName"
          v-bind:label="gName">
            <option
              v-for="shortcut in groups[gName]"
              v-bind:key="shortcut.name"
              v-bind:value="shortcut"
            >{{shortcut.name}}
            </option>
        </optgroup>
      </select>
    </span>
    <button v-if="inInerMode" v-bind:class="{ fullModeButton: fullMode }" id="fullModeInput"
            v-on:click="fullMode = !fullMode">
      <font-awesome-icon v-if="!fullMode" icon="sliders-h"/>
      <font-awesome-icon v-if="fullMode" icon="times"/>
    </button>
    <span class="geographySelect-label"><strong>&#x2514; by:</strong></span>
    <span id="geographySelect">
      <select v-on:change="setGeoType($event.target.value)">
        <option disabled value="">Choose a Geography Type</option>
        <option
          v-for="id in geotypesForMap"
          v-bind:key="id"
          v-bind:value="id"
          v-bind:selected="geotype===id"
        >{{namesFromGeotype[id].name}}
        </option>
      </select>
      <select v-if="fullMode" v-model="selectedClassifier">
        <option disabled value="">Classifier</option>
        <option
          v-for="id in classifiers"
          v-bind:key="id"
          v-bind:value="id">{{id}}
        </option>
      </select>
    </span>
  </div>
</template>
<script>
import IndSelect from './IndSelect.vue'
export default {
  name: 'ShortcutSelect',
  props: [
    'mappedIndicator',
    'normalizationIndicator',
    'indFromName',
    'groupNames',
    'groups',
    'selectedShortcut',
    'inInerMode',
    'namesFromGeotype',
    'geotypesForMap',
    'geotype',
  ],
  components: { IndSelect },
  data: function () {
    return {
      fullMode: false,
      dropdownShortcut: this.selectedShortcut,
      selectedClassifier: null,
    }
  },
  computed: {
    classifiers: function () {
      return [
        'divergingRatio',
        'AreaNaturalBreaks',
        'AreaLogNaturalBreaks',
        'NaturalBreaks',
        'LogNaturalBreaks',
        'AreaViewportPercentile',
        'viewportPercentile',
      ]
    },
  },
  methods: {
    setIndicator: function (id) {
      if (id && this.mappedIndicator && this.mappedIndicator !== this.id) {
        this.$emit('set-ind', id)
      }
    },
    setNormalization: function (id) {
      if (id && this.normalizationIndicator && this.normalizationIndicator !== this.id) {
        this.$emit('set-norm', id)
      }
    },
    setMap: function (numerator, denominator) {
      let ifN = numerator && this.mappedIndicator && this.mappedIndicator !== numerator
      let ifD = denominator && this.normalizationIndicator && this.normalizationIndicator !== denominator
      if (ifN && ifD) {
        this.$emit('set-map', [numerator, denominator])
      } else if (ifN) {
        this.$emit('set-ind', numerator)
      } else if (ifD) {
        this.$emit('set-norm', denominator)
      }
    },
    setGeoType: function (id) {
      this.$emit('set-geo-type', id)
    },
  },
  watch: {
    dropdownShortcut: function () {
      if (this.dropdownShortcut) {
        this.setMap(this.dropdownShortcut.numerator, this.dropdownShortcut.denominator)
      }
    },
    selectedShortcut: function () {
      this.dropdownShortcut = this.selectedShortcut
      if (this.selectedShortcut) {
        this.selectedClassifier = this.selectedShortcut.classification
      }
    },
    fullMode: function () {
      if (!this.selectedShortcut) {
        this.setMap('totalpop_18', 'acres')
      }
    },
    selectedClassifier: function () {
      this.$emit('override-classification', this.selectedClassifier)
    },
  },
}
</script>
<style scoped>
  div {
    position: relative;
    display: grid;
    grid-template-columns: max-content 1fr max-content max-content;
    grid-template-rows: max-content auto max-content;
    column-gap: 2px;
    align-items: end;
    width: 100%;
  }

  #mapIndSelect {
    grid-column: 2;
    grid-row: 1;
    min-width: 0;
  }

  #normIndSelect {
    grid-column: 2;
    grid-row: 2;
    min-width: 0;
  }

  #geographySelect {
    grid-column: 2;
    grid-row: 3;
    min-width: 0;
  }

  .mapInd-label {
    grid-column: 1;
    grid-row: 1;
    min-width: 0;
    font-size: smaller;
  }

  .normInd-label {
    grid-column: 1;
    grid-row: 2;
    min-width: 0;
    font-size: smaller;
  }

  .geographySelect-label {
    grid-column: 1;
    grid-row: 3;
    min-width: 0;
    font-size: smaller;
  }

  .geographySelect-label strong {
    padding-left: .2em;
  }

  #shortcutMode {
    grid-row: 2;
    grid-column: 1 / 3;
    min-width: 0;
  }

  #fullModeInput {
    grid-column: 3;
    grid-row: 2;
    width: 25px;
    height: 25px;
    display: block;
    padding: 0;
    outline: none;
    border: 1px solid black;
    border-radius: 4px;
    box-sizing: border-box;
    background-color: transparent;
  }

  .fullModeButton {
    grid-row: 1 !important;
  }

  select {
    border-color: #f3f3f3;
    border-radius: 10px;
    max-width: 100%;
  }

  select:focus {
    outline: 0;
    border-color: black;
  }

  select option{
    font-size: 1rem;
  }

  @media (max-width: 925px) and (min-width: 576px) {
    div {
      grid-template-columns: 1fr max-content max-content;
      grid-template-rows: auto max-content max-content auto max-content auto;
    }

    #mapIndSelect {
      grid-column: 1;
      grid-row: 2;
    }

    #normIndSelect {
      grid-column: 1;
      grid-row: 4;
    }

    .mapInd-label {
      grid-column: 1;
      grid-row: 1;
    }

    .normInd-label {
      grid-column: 1;
      grid-row: 3;
    }

    #shortcutMode {
      grid-column: 1;
      grid-row: 2;
    }

    .geographySelect-label {
      grid-column: 1;
      grid-row: 5;
    }

    #geographySelect {
      grid-column: 1;
      grid-row: 6;
    }

  }
</style>
